import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { supabase } from '../supabase/client'
import './Header.css'

const Header = ({ user }) => {
  const navigate = useNavigate()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut()
    if (error) console.error('Logout error:', error)
    navigate('/login')
    setIsMenuOpen(false)
  }

  return (
    <div className="header">
      <div className="logo">
        <Link to="/">
          <img src="/logotype.svg" alt="Business Evolution AI" style={{ height: '50px' }} />
        </Link>
      </div>
      {user && (
        <div className="user-section">
          <span className="user-name">{user.user_metadata.name || 'User'}</span>
          <button onClick={toggleMenu} className="avatar-btn">
            {!user.user_metadata?.avatar_url ? (
              <img src={user.user_metadata?.avatar_url} alt="Avatar" className="avatar" />
            ) : user.user_metadata?.firstName && user.user_metadata?.lastName ? (
              user.user_metadata?.firstName[0] + user.user_metadata?.lastName[0]
            ) : (
              '👤'
            )}
          </button>
          {isMenuOpen && (
            <div className="account-menu">
              <button onClick={handleLogout} className="logout-btn">
                🚪 Logout
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default Header
